<script setup>
import { onMounted } from 'vue'
import MarketItem from './market-item.vue'
import DesignFooter from '@/components/DesignFooter.vue'
import { setTrack } from '@/api/login'

const heroImage = `${import.meta.env.BASE_URL}image/market-redesign/banner.png`

onMounted(async () => {
  await setTrack({
    position: 'algorithm_market',
  })
})
</script>

<template>
  <Header design-always hide-banner />

  <main class="market-page">
    <section class="market-hero" aria-labelledby="market-title">
      <img :src="heroImage" class="market-hero-image" alt="" fetchpriority="high" />
      <div class="market-hero-content">
        <h1 id="market-title">AlgoStore算法超市</h1>
        <p class="market-hero-description">一站式算法服务平台，提供多元算法资源与灵活调用方式，助力快速构建智能化能力</p>
      </div>
    </section>

  <a-config-provider
    :theme="{
      token: {
        colorPrimary: '#ed000c',
      },
    }"
  >
    <Suspense>
      <MarketItem />
    </Suspense>
  </a-config-provider>
  </main>

  <DesignFooter />
</template>

<style lang="scss" scoped>
.market-page { color: #14233b; }
.market-hero { position: relative; display: flex; align-items: center; min-height: 416px; padding: 64px 0; box-sizing: border-box; background: #0d182b; color: #fff; }
.market-hero-image { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
.market-hero::after { content: ''; position: absolute; inset: 0; background: rgb(13 24 43 / 60%); }
.market-hero-content { position: relative; z-index: 1; width: min(1440px, calc(100% - 48px)); margin: 0 auto; }
.market-hero-content h1 { margin: 0 0 16px; color: #fff; font-size: 30px; font-weight: 600; line-height: 1.3; }
.market-hero-description { margin: 0; font-size: 16px; line-height: 1.5; }
@media (min-width: 768px) { .market-hero-content h1 { font-size: 36px; } .market-hero-description { font-size: 18px; } }
@media (min-width: 992px) { .market-hero-content h1 { font-size: 40px; } .market-hero-description { font-size: 18px; } }
@media (min-width: 1200px) { .market-hero-content h1 { font-size: 44px; } .market-hero-description { font-size: 18px; } }
@media (max-width: 767px) { .market-hero { min-height: 280px; padding: 40px 0; } .market-hero-content { width: calc(100% - 32px); } }
.bg-white {
  .container {
    background-color: #eff6ff;

    .content {
      width: 100%;
      margin-left: auto;
      margin-right: auto;
      position: relative;
      z-index: 10;
      .max-w-3xl {
        text-align: center;
        max-width: 48rem;
        margin-left: auto;
        margin-right: auto;
        .h1-title {
          color: rgb(17, 24, 39);
          font-weight: 700;
          margin-bottom: 1rem;
        }

        .text-xl {
          color: rgb(75, 85, 99);
          font-size: 1.25rem;
          line-height: 1.75rem;
        }
      }
    }
  }

  @media (min-width: 768px) {
    .md\:py-32 {
      padding-top: 8rem;
      padding-bottom: 8rem;
    }
  }
  @media (min-width: 768px) {
    .md\:px-6 {
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }
  }
  @media (min-width: 1280px) {
    .content {
      max-width: 1280px;
    }
  }
  @media (min-width: 1024px) {
    .content {
      max-width: 1024px;
    }
  }
  @media (min-width: 768px) {
    .content {
      max-width: 768px;
    }
  }
  @media (min-width: 640px) {
    .content {
      max-width: 640px;
    }
  }
  @media (min-width: 768px) {
    .md\:text-5xl {
      font-size: 3rem;
      line-height: 1;
    }
  }
}
</style>
